import React from 'react';

/**
 * This context provides the domain name to use for the cookie,
 * set by the main LocationLite provider. Generally, consumers
 * won't need to access this directly
 */
var LocationLiteDomainContext = React.createContext(undefined);

export { LocationLiteDomainContext };
//# sourceMappingURL=context.esm.js.map
